import { render, staticRenderFns } from "./customers-table-details-row.vue?vue&type=template&id=7a83158c&scoped=true"
import script from "./customers-table-details-row.vue?vue&type=script&lang=js"
export * from "./customers-table-details-row.vue?vue&type=script&lang=js"
import style0 from "./customers-table-details-row.vue?vue&type=style&index=0&id=7a83158c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83158c",
  null
  
)

export default component.exports